import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Banner from './Banner';
import { Link, Navigate, NavLink, useNavigate } from 'react-router-dom';
import './home.scss';
import { APP_LOAD, HANDLE_401_ERROR, SERVICE_LOAD, USER_LOAD } from '../../constants/actionTypes';
import agent from '../../agent';
import { Helmet } from "react-helmet";
import CustomFunction from '../../components/customFuction';
import axios from "axios";
import closeIcon from "../TuneUp/CloseIcon.svg"
import Modal from 'react-modal';
import { useForm, Controller, set } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import userEvent from '@testing-library/user-event';
import Footer from '../../components/Footer/Footer';
 
const mapStateToProps = state => {
  return {
    ...state,
    UserData: state.common.currentUser,
    servicesData: state.services.service
  }
};

const mapDispatchToProps = dispatch => ({
  onLoad: (payload) =>
    dispatch({ type: SERVICE_LOAD, payload, skipTracking: true }),
  onAppLoad: (payload) =>
    dispatch({ type: APP_LOAD, payload, skipTracking: true }),
});

const Home = (props) => {

 // console.log("props on home screen", props);
  const [isLoading, setLoading] = useState(true);
  const [isButtonLoading, setButtonLoading] = useState(false);
  const [paymentModalIsOpen, setPaymentModalISOpen] = useState(false);
  const [paymentUpdateModel, setPaymentUpdateModel] = useState(false);
  const [paymentCompleteSuccess, setPaymentCompleteSuccess] = useState('');
  const [paymentCompleteError, setPaymentCompleteError] = useState('');
  const [paymentInfoError, setPaymentInfoError] = useState("");
  const [userId, setUserID] = useState("");


  const [paymentChargeSuccess, setPaymentChargeSuccess] = useState([]);
  const [paymentChargeError, setPaymentChargeError] = useState('');
  const [paymentTipData, setPaymentTipData] = useState('');
  const [paymentChargeId, setPaymentChargeId] = useState([]);
  const navigate = useNavigate();

  const validationSchema = Yup.object({
    order_payment_tip: Yup.string().nullable()
  });

  const formOptions = { resolver: yupResolver(validationSchema) };

  const { register, handleSubmit, setValue, control, reset, formState: { errors } } = useForm(formOptions);



  useEffect(() => {
    props.onLoad(agent.Services.current());
    // getProfileInfo();
    setPaymentModalISOpen(false);

    const token = window.localStorage.getItem('access_token');
    if (token) {
      let tokenParse = JSON.parse(token)
      agent.setToken(tokenParse);
    }
    props.onAppLoad(token ? agent.Auth.current() : null, token);

    setTimeout(() => {
      setLoading(false)
    }, 2500);
  }, []);


  const customStyles1 = {
    content: {
      top: 47,
      left: 0,
      right: 0,
      margin: '0 auto',
      background: 'rgba(255, 255, 255, 0.95)',
      maxWidth: '550px',
      padding: '30px 15px 0',
      width: '100%',
      maxHeight: '460px',
      borderRadius: '30px',
      border: '0.5px solid #000000'
    }
  };

  const customStyles = {
    content: {
      top: '40%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translate(-50%, -50%)',
      background: '#fff',
      maxWidth: '400px',
      padding: '30px 15px',
      width: '90%'
    },
  };


  const customStyles2 = {
    content: {
      // top: '160px',
      left: 0,
      right: 0,
      bottom: '160px',
      margin: '0 auto',
      background: 'rgba(255, 255, 255, 0.95)',
      maxWidth: '520px',
      padding: '30px 15px 0',
      width: '100%',
      maxHeight: '360px',
      borderRadius: '30px',
      border: '0.5px solid #000000'
    }
  };




  let servicesDataIn = null;
  servicesDataIn = props.servicesData?.results;
  let CurrentUserData = props.UserData;
  
  let UserDataId = props.UserData?.results?._id;
  // console.log("user data", UserDataId);
  const paymentModalIsCloseModal = (charge, index) => {
    setPaymentModalISOpen(false);
    // paymentComplete1(charge, index);
    // navigate('/home');
    // navigate(`/order-details/${orderSuccess?.results?._id}`);
  }

  const getProfileInfo = async () => {
    setLoading(true)
    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
          'x-request-time' : new Date().toString(),
          'x-request-timezone': timeZone
        },
      };
      const { data } = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + 'user', config);
      setUserID(data?.results?._id);
      setLoading(false);
    }
    catch (error) {
      setPaymentChargeError(error);
      HANDLE_401_ERROR(error.response?.status);
    //  console.log('error on payment charge', error);

    }
  
  }
  

  const getPaymentChargeInfo = async () => {
    setLoading(true)
    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
          'x-request-time' : new Date().toString(),
          'x-request-timezone': timeZone
        },
      };
      const { data } = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + `payment/pending-charges/user/${UserDataId}`, config);
     // console.log("Pending charge data", data);
      setPaymentChargeSuccess(data?.results);
      setLoading(false)
    } catch (error) {
      setLoading(false)
      HANDLE_401_ERROR(error.response?.status);
    //  console.log(error)
    }
  };
  //console.log("payment-charge-id", paymentChargeId);



 // console.log("userId", userId);
  //console.log("payment charge data", paymentChargeSuccess);


  useEffect(() => {
    if (UserDataId) {
      getPaymentChargeInfo();
    }
  }, [UserDataId]);

  const handleFormSubmit = async (data, charge, index) => {
    //console.log("data on submit", data);
    // console.log("selected payment charge", paymentChargeSuccess[index])

    let tip = paymentTipData;
    if (!tip) {
      tip = 0;
    }
    setButtonLoading(true)
    setPaymentInfoError('')
    setTimeout(() => {
      setPaymentUpdateModel(true);
    }, 2000)
    paymentComplete(charge, data, index, tip);
  }

  const paymentComplete = async (data, charge, index, tip) => {
    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    setPaymentChargeId(paymentChargeSuccess[index].order)
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
          'x-request-time' : new Date().toString(),
          'x-request-timezone': timeZone
        },

      };
      const val = {
        tip_cost: tip
      };
      // const userID = props?.common?.currentUser?.results?._id;
      //console.log("tip-payment", paymentTipData);

      const response = await axios.post(process.env.REACT_APP_RIDEDOC_API_ROOT + `payment/charge/${paymentChargeSuccess[index]._id}/complete`, val, config);
      // console.log("time slot response", response?.data?.results?.availabe_slots);
      setPaymentCompleteSuccess(response);
      setButtonLoading(false);
      setPaymentUpdateModel(true);
      setPaymentModalISOpen(false);
     

      // navigate('/order-details/' + paymentChargeSuccess[index].order);
    } catch (error) {
      setPaymentInfoError(error.response.data.message)
      setButtonLoading(false)
      setPaymentModalISOpen(false);
      setPaymentCompleteError(error);
      HANDLE_401_ERROR(error.response?.status);
    //  console.log("payment charge complete error", error);
    }
  }

  // const paymentComplete1 = async (charge, index) => {
  //   const accessToken = JSON.parse(localStorage.getItem("access_token"));
  //   const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
  //   try {
  //     const config = {
  //       headers: {
  //         "Content-Type": "application/json",
  //         'x-access-token': `${accessToken}`,
  //         'x-request-time' : new Date().toString(),
  //         'x-request-timezone': timeZone
  //       },

  //     };
  //     const val = {
  //       tip_cost: '0'
  //     };
  //     // const userID = props?.common?.currentUser?.results?._id;
  //    // console.log("tip-payment on close", paymentTipData);
  //     const response = await axios.post(process.env.REACT_APP_RIDEDOC_API_ROOT + `payment/charge/${charge?._id}/complete`, val, config);
  //     // console.log("time slot response", response?.data?.results?.availabe_slots);
  //     setPaymentCompleteSuccess(response?.data);
  //     setButtonLoading(false);
  //     // navigate('/order-details/' + paymentChargeSuccess[index].order);
  //   } catch (error) {
  //     setPaymentInfoError(error)
  //     setButtonLoading(false)
  //     HANDLE_401_ERROR(error.response?.status);
  //    // console.log("payment charge complete error", error);
  //   }
  // }


  useEffect(() => {
    if (paymentChargeSuccess && paymentChargeSuccess.length > 0) {
      console.log('payment is large');
      setPaymentModalISOpen(true);
    } else {
      console.log('payment is small');
      setPaymentModalISOpen(false);
    }
  }, [paymentChargeSuccess]);


  const handleInput = (e) => {
    setPaymentTipData(e.target.value);
  }

  function bookingModalIsCloseModal() {
    // setBookingModalISOpen(false);
    setPaymentUpdateModel(false);
    setPaymentModalISOpen(false);

    // navigate('/order-details/' + paymentChargeId);
  }

  const handleButtonClick = () => {
    setPaymentUpdateModel(false);
    setPaymentModalISOpen(false);
    // navigate('/order-details/' + paymentChargeId);
  }



  // console.log("service_data", servicesDataIn);
  // debugger;
  // let isLoggedIn = null;
  // isLoggedIn = props?.common?.currentUser;
  // console.log("isLoggedIn", props?.common?.currentUser);
  return isLoading ? (   //Checkif if is loading
    <div className="lds-ripple"><div></div><div></div></div>
  ) : (
    <React.Fragment>
      <div className='home_bg'>
        <div className='main'>
          <Helmet>
            <title>RideDoc | Home</title>
            <meta name="description" content="Mobile bike mechanics at your door step" />
          </Helmet>
          <div className='header-wrp logo_header'>
            <header className='hd-centered'>
              <Link to="/home" className="logo" style={{ marginTop: 40 }}>
                <img src={process.env.PUBLIC_URL + '/logo.png'} alt="RideDoc" />
              </Link>
            </header>
            <h3 className='h5' style={{ paddingTop: "1.5rem", fontWeight: 400 }}>Mobile bike mechanics at your door step</h3>
          </div>
          <div className="main-wrapper">
            <div className="header-wrapper">
              {/* <Banner token={props.token} /> */}
              <section className="ser-wrp">
                <div className="ser-hd">
                  <h1 className='h2 text-center'>Book Now</h1>
                </div>
                <div className="ser-cnt">
                  <div className="ser-cnt-lst-wrp">

                    <div className="ser-item">
                      {servicesDataIn?.map((service) => (
                        <>
                          <div className="ser-item-in" key={service.id} >
                            <Link to={CustomFunction.isAuthenticated() ? "/services/" + service.name : "/signup"}
                              state={{
                                plans: service.plans,
                                plans_title: service.display_name,
                                service: service.name,
                                service_id: service._id,
                                UserData: CurrentUserData,
                                userAddres: props?.common?.currentUser?.results?.address?.address
                              }}
                              className="ser-link" style={{ marginTop: "38px" }}>
                              <span className='ser-link-ic'>
                                <img src={service.image_url} alt="" />
                              </span>
                              <span className='ser-txt' style={{ paddingTop: "11px" }}>{service.display_name}</span>
                            </Link>
                          </div>
                        </>
                      ))}
                    </div>
                  </div>
                </div>
              </section>
              {/* Home Design completed */}
            </div>
          </div>
        </div>
      <Footer />
    </div>


      {paymentModalIsOpen && (
        <>
          {paymentChargeSuccess.map((charge, index) => {
            const handleCloseModal = () => paymentModalIsCloseModal(charge, index);
            return (
              <Modal
                key={index}
                isOpen={paymentModalIsOpen}
                onRequestClose={handleCloseModal}
                shouldCloseOnOverlayClick={false}
                shouldCloseOnEsc={false}
                ariaHideApp={false}
                style={customStyles}
                // className="time-slot-popup"
                overlayClassName="modal-Overlay"
                contentLabel="bookingOrderTimeSlot"
              >
                <h3 style={{ textAlign: "center", fontSize: 20, paddingTop: 20 }}>Payment Confirmation</h3><br></br>
                <div className="rd-popup-hd rd-popup-hd-orderid">
                  Order No : {charge.ref_id}
                </div>
                <div className="rd-popup-hd rd-popup-hd-servicecost">
                  Service Cost : ${(charge?.total_service_adjustment_cost ?? 0).toFixed(2)}
                </div>

<div className="rd-popup-hd rd-popup-hd-partcost">
  Parts Cost : ${(charge?.parts_cost ?? 0).toFixed(2)}
</div>

<div className="rd-popup-hd rd-popup-hd-discount">
  Discount : -${(charge?.order?.promo_discount_amount ?? 0).toFixed(2)}
</div>

<div className="rd-popup-hd rd-popup-hd-tax">
  Tax ({charge?.state_tax_percentage ?? 0}%) : ${(charge?.state_tax_cost ?? 0).toFixed(2)}
</div>

<div className="rd-popup-hd rd-popup-hd-totcost">
  Total Cost : ${(charge?.customer_total_billing_cost ?? 0).toFixed(2)}
</div>
                <div className='booking-wrp tips-popup'>
                  <div className='rd-popup-wrp' style={{display: "initial"}}>
                    {/* {console.log("order-success", paymentChargeSuccess)} */}
                    <section className="profile-info-sec-wrp" style={{marginLeft: "2rem", marginRight: "2rem"}}>
                      <div className="rd-popup-close">
                        <button className='reg-close' onClick={handleCloseModal}>
                          <img src={closeIcon} alt='close Icon' />
                        </button>

                      </div>
                      {/* {paymentChargeError && <span className='error'>{paymentChargeError}</span>}
                    {paymentChargeSuccess && <span className='success'>{paymentChargeSuccess}</span>} */}
                      <form onSubmit={handleSubmit((data) => handleFormSubmit(data, charge, index))}>



                        <div className="form-group-wrp">
                          <div className="row">
                            <div className="col">
                              <div className="form-group">
                              <label className="form-lbl form-lbl-profileinfo" htmlFor="order_payment_tip" style={{top: "-6px", color: "black", backgroundColor: "white"}}>Tips</label>
                              <input className="form-control form-height" type="text" defaultValue=""  {...register('order_payment_tip')} onInput={handleInput} name="order_payment_tip" id="order_payment_tip" />
                                {/* <input hidden className="form-control"  {...register('payment_charge_id')} defaultValue={charge._id} type="text" name="payment_charge_id" id="payment_charge_id" />
                                <input readOnly className="form-control" style={{ marginBottom: 30 }} {...register('payment_charge_amount')} defaultValue={charge.customer_total_billing_cost} type="text" name="payment_charge_amount" id="payment_charge_amount" />
                                <label className="form-lbl form-lbl-payment" style={{ fontSize: 10 }} htmlFor="payment_charge_amount">Total Cost</label> */}
                                
                              </div>
                              {errors.order_payment_tip &&
                                <div className="invalid-feedback">{errors?.order_payment_tip.message}</div>
                              }
                            </div>
                          </div>
                        </div>


                        {isButtonLoading ?
                          <div className="btn btn-primary">Loading...</div>
                          :
                          <button className="btn btn-primary" type="submit">Pay Now</button>
                        }
                      </form>
                    </section>
                  </div>
                </div>
              </Modal>


            )
          })};
        </>

      )}

      {paymentUpdateModel && (
        <>
          <Modal
            isOpen={paymentUpdateModel}
            onRequestClose={bookingModalIsCloseModal}
            shouldCloseOnOverlayClick={false}
            ariaHideApp={false}
            style={customStyles}
            overlayClassName="modal-Overlay"
            contentLabel="bookingOrderTimeSlot"
          >
            <div className='booking-wrp order-booking-time-popup'>
              <div className='rd-popup-wrp'>
                <div className="rd-popup-hd">
                  {/* <div className="rd-popup-close">

                <button className='reg-close' onClick={bookingModalIsCloseModal}>
                  <Icon path={mdiClose} size={'15px'} color="#222" />
                </button>
              </div> */}
                </div>
                {paymentCompleteSuccess && (
          <div className="rd-popup-content payment-message">
            <p className="pb20">Payment Updated Successfully.</p>
            <div className="ok-button" style={{ width: "4.5rem", margin: "0 auto" }}>
              <button
                className="btn btn-primary btn-update-ok"
                onClick={handleButtonClick}
              >
                Ok
              </button>
            </div>
          </div>
        )}   
        {paymentCompleteError && (
          <div className="rd-popup-content payment-message">
            <p className="pb20">Payment Updated Failed.</p>
            <div className="ok-button" style={{ width: "4.5rem", margin: "0 auto" }}>
              <button
                className="btn btn-primary btn-update-ok"
                onClick={handleButtonClick}
              >
                Ok
              </button>
            </div>
          </div>
        )}
              </div>
            </div>
          </Modal>
        </>
      )}
    </React.Fragment >

  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);
